import { Dialog, DialogContent, DialogTitle } from "@mui/material"
import { Filter, useTranslate } from "react-admin";
import FilterGroup from "../../components/FilterGroup";
import { useMemo } from "react";
import { XDateTimeInput } from "../../components/XDateTimeInput";
import TransferTable from "./TransferTable";

interface Props {
  open: boolean;
  onClose: () => void;
  record: any;
  transactionType: string;
  asset: string;
}

const TransferDialog = ({ open, onClose, record, transactionType, asset }: Props) => {
  const t = useTranslate();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>{`${t('module.userInfo.transferHistory.title')} - ${asset.toUpperCase()} - ${transactionType.toUpperCase()}`}</DialogTitle>
      <DialogContent>
        <TransferTable record={record} transactionType={transactionType} asset={asset} isDialog/>
      </DialogContent>
    </Dialog>
  )
}

export default TransferDialog